/**
 * Szöveg a vágólapra. `false`, ha a böngésző nem engedte.
 *
 * A vágólap-API csak biztonságos (https) oldalon és a böngésző engedélyével
 * érhető el. A hívás eredményét korábban senki nem nézte meg: a gomb akkor is
 * „Másolva” feliratra váltott, ha semmi nem került a vágólapra — a
 * felhasználó beillesztéskor egy korábbi tartalmat kapott.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Megtagadott engedély vagy fókusz nélküli lap — jön a régi módszer.
  }
  return legacyCopy(text);
}

function legacyCopy(text: string): boolean {
  const area = document.createElement("textarea");
  area.value = text;
  area.setAttribute("readonly", "");
  area.style.position = "fixed";
  area.style.opacity = "0";
  document.body.appendChild(area);
  area.select();
  try {
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    area.remove();
  }
}
